const questionPool = [
    {
      id: 1,
      text: 'What is the last known bounty of William?',
      correctAnswer: "600000000",
    },
    {
      id: 2,
      text: 'What is the last known bounty of Ragnar?',
      correctAnswer: "350000000",
    },
    {
      id: 3,
      text: 'What is the last known bounty of Duros?',
      correctAnswer: "300000000",
    },
    {
      id: 4,
      text: 'What is the last known bounty of Verona?',
      correctAnswer: "299000000",
    },
    {
      id: 5,
      text: 'What was the YouTube name of Episode 59?',
      correctAnswer: "Broken Chains",
    },
    {
      id: 6,
      text: 'Who was Atom\'s and Molly\'s father? (1 word)',
      correctAnswer: "Gunner",
    },
    {
      id: 7,
      text: 'In which episode Doxie was introduced?',
      correctAnswer: "49",
    },
    {
      id: 8,
      text: 'Who draws character\'s artwork?',
      correctAnswer: "Kaerru",
    },
    {
      id: 9,
      text: 'Who was the ruler of Oasis before Big Top?',
      correctAnswer: "The Dice King",
    },
    {
      id: 10,
      text: 'Which member of the Eight Flames to make an appearance was Hemlock? (format: number)',
      correctAnswer: "3",
    },
    {
      id: 11,
      text: 'What is the latest known total bounty of The Devil\'s Luck Pirates?',
      correctAnswer: "1759000000",
    },
    {
      id: 12,
      text: 'What is the current title that Luna holds?',
      correctAnswer: "God-Empress",
    },
    {
      id: 13,
      text: 'Who Heali has a crush on?',
      correctAnswer: "Hurtie",
    },
    {
      id: 14,
      text: 'What was William\'s last name?',
      correctAnswer: "Chapston",
    },
    {
      id: 15,
      text: 'What was William\'s mother\'s name?',
      correctAnswer: "Marissa",
    },
    {
      id: 16,
      text: 'What was William\'s father\'s name?',
      correctAnswer: "Montgomery",
    },
    {
      id: 17,
      text: 'What is Boss\'s favorite fruit?',
      correctAnswer: "Banana",
    },
    {
      id: 18,
      text: 'What is the real name of The All Mother?',
      correctAnswer: "Rain",
    },
    {
      id: 19,
      text: 'What is the name of the cult led by The All Mother?',
      correctAnswer: "The Aeons",
    },
    {
      id: 20,
      text: 'Who has the highest kill count out of the main 4 in OP D&D?',
      correctAnswer: "Verona",
    },
  ];
  
  export default questionPool;
  